import { MakeLogicType, connect, kea, path, selectors } from 'kea'

import { userLogic } from 'scenes/userLogic'

import { PendingInviteForCurrentUser } from '~/types'

import type { UserType } from '../../../types'

export type { PendingInviteForCurrentUser }

// Generated by kea-typegen. Update if you're an agent, ignore if you're human.
export interface pendingInvitesLogicValues {
    user: UserType | null // userLogic
    pendingInvites: PendingInviteForCurrentUser[]
}

// Generated by kea-typegen. Update if you're an agent, ignore if you're human.
export interface pendingInvitesLogicMeta {
    __keaTypeGenInternalSelectorTypes: {
        pendingInvites: (user: UserType | null) => PendingInviteForCurrentUser[]
    }
}

export type pendingInvitesLogicType = MakeLogicType<
    pendingInvitesLogicValues,
    {},
    Record<string, any>,
    pendingInvitesLogicMeta
>

export const pendingInvitesLogic = kea<pendingInvitesLogicType>([
    path(['lib', 'components', 'Account', 'pendingInvitesLogic']),
    connect(() => ({
        values: [userLogic, ['user']],
    })),
    selectors({
        pendingInvites: [
            (s) => [s.user],
            (user: null | import('~/types').UserType): PendingInviteForCurrentUser[] => user?.pending_invites ?? [],
        ],
    }),
])
